/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable indent */
/* eslint-disable no-else-return */
/* eslint-disable react/no-array-index-key */
// @flow
/* eslint-disable react/no-danger */
import * as React from 'react';
import classNames from 'classnames';
import _ from 'lodash';
import { APP_CONFIG } from 'common/constants';
import { COLLECTIONS, MAKO_ANALYTICS_PAGE_IDS, IS_DEVEL } from 'client/constants';

import { RabbiCredit, Responsive, MakoAnalytics, Embed, BottomLink } from 'client/components/common';
import { type EnhancedProps, withTransition } from 'client/components/common/HOCs/with-transition';
import { fileLink } from 'common/utils/file-link';
import { analytics } from 'common/utils/ga';
import { EqualHeight, EqualHeightElement } from 'react-equal-height/clean';

import playIconSrc from 'assets/client/play-icon.svg';

import Socials from 'client/components/common/Socialls';
import VideoFrame from './VideoFrame';
import SelectBtn from './SelectBtn';
import ExpandText from './ExpandText';

import * as css from './MainContent.scss';

type Props = {|
	...EnhancedProps,
	className?: string,
	in: boolean,
	galleryData: {
		checklistInfo: ChecklistsItem,
		gallery: GalleryItems,
	},
	updateSelected: Function,
	onFinishClick: Function,
	updateVotes: Function,
	selectedItems: Array<GalleryItemInfo>,
	checklistInfo: ChecklistsItem,
	parentURL: string,
	location: RouterLocation,
	userInfo: User,
	setRegistredUserVotesInfo: Function,
|};

type State = {
	selected: GalleryItems | [],
	finishButtonClicked: boolean,
	isActivePopUp: boolean,
	activePopUpItem: string,
	gallery: Array<GalleryItemInfo>,
	isShowMaxPopup: boolean,
	loaded: boolean,
	activeVideoId: string,
};

class MainContent extends React.PureComponent<Props, State> {
	transitionCompleteTimeout: TimeoutID;
	isShowMax: boolean;

	static defaultProps = {
		className: '',
	};

	constructor(props: Props) {
		super(props);
		this.state = {
			selected: [],
			finishButtonClicked: false,
			isActivePopUp: false,
			activePopUpItem: '',
			gallery: [],
			isShowMaxPopup: false,
			loaded: false,
			activeVideoId: '',
		};

		this.isShowMax = false;
	}

	componentDidMount() {
		const { onTransitionComplete, selectedItems, galleryData, checklistInfo } = this.props;
		this.transitionCompleteTimeout = setTimeout(onTransitionComplete, parseInt(css.transitionIn, 10));

		const gallery = _.get(galleryData, 'gallery', []);
		const isRandom = _.get(checklistInfo, 'general.isRandom', false);
		let items;

		// create array for gallery
		if (isRandom) {
			items = _.shuffle(gallery);
		} else {
			items = gallery;
		}

		this.setState((state: any) => {
			const selected = [...state.selected];
			_.each(selectedItems, item => {
				selected.push(item.id);
			});
			return {
				selected,
				gallery: items,
			};
		});

		setTimeout(() => {
			this.setState({ loaded: true });
		}, 300);

		if (!IS_DEVEL) {
			const location = `${APP_CONFIG.domains.client.hostname}/gallery`;
			analytics.gtag.event('page_view', {
				page_title: 'gallery',
				page_location: `${location}`,
				page_path: `/gallery`,
			});
		}
	}

	componentDidUpdate(prevProps: Props) {
		if (this.props.in !== prevProps.in) {
			const { onTransitionComplete } = this.props;
			let duration = parseInt(this.props.in ? css.transitionIn : css.transitionOut, 10);

			if (!this.props.in) {
				duration = 0;
			}
			clearTimeout(this.transitionCompleteTimeout);
			this.transitionCompleteTimeout = setTimeout(onTransitionComplete, duration);
		}
	}

	get selectedItems() {
		const items = _.get(this.props, 'galleryData.gallery', []);
		return _.filter(items, item => this.state.selected.includes(item.id));
	}

	onItemClick = e => {
		const { checklistInfo } = this.props;

		const { id } = e.currentTarget.dataset;

		const isMultiple = Number(_.get(this.props, 'checklistInfo.general.isMultiple', '0'));

		const numberOfChoices = _.get(checklistInfo, 'general.numberOfChoices', 3);

		const isSingle = numberOfChoices === 1;

		// ga.onItemSelected(title);
		// console.info('numberOfChoices', numberOfChoices);
		// console.info('isMultiple', isMultiple);
		// console.info('selected', this.state.selected);
		// FIXME refactor with database
		if (isMultiple) {
			this.setState((state: any) => {
				const selected = [...state.selected];

				if (selected.includes(id)) {
					_.remove(selected, v => v === id);
				} else selected.push(id);

				return {
					selected,
				};
			});
		} else if (isSingle) {
			this.setState((state: any) => {
				let selected = [...state.selected];
				if (selected.includes(id)) {
					_.remove(selected, v => v === id);
				} else {
					selected = [];
					selected.push(id);
				}

				return {
					selected,
				};
			});
		} else if (!isMultiple || numberOfChoices !== 1) {
			this.setState((state: any) => {
				const selected = [...state.selected];
				const beforeSelected = [...state.selected];
				let isShowMaxPopup = false;
				if (selected.includes(id)) {
					_.remove(selected, v => v === id);
				} else if (numberOfChoices > _.size(selected)) selected.push(id);
				if (
					selected.length === beforeSelected.length &&
					numberOfChoices === selected.length &&
					!this.isShowMax
				) {
					this.isShowMax = true;
					isShowMaxPopup = true;
				}

				return {
					selected,
					isShowMaxPopup,
				};
			});
		}
	};

	onCloseMaxPopup = () => {
		this.isShowMax = false;
		this.setState({
			isShowMaxPopup: false,
		});
	};

	onFinishClick = async e => {
		e.preventDefault();
		const {
			updateSelected,
			updateVotes,
			checklistInfo,
			location,
			galleryData,
			userInfo,
			setRegistredUserVotesInfo,
		} = this.props;
		const { selected } = this.state;

		const isOneVotingPerUser = _.get(checklistInfo, 'general.isOneVotingPerUser', false);
		const isWithRegistration = _.get(checklistInfo, 'general.isWithRegistration', false);

		const id = _.get(checklistInfo, 'id', '');
		const reqData = {
			collection: COLLECTIONS.VOTES,
			id,
			items: selected,
			userUid: userInfo.uid || null,
		};

		this.setState({ finishButtonClicked: true });

		updateSelected(this.selectedItems);
		await updateVotes(reqData);

		if (isWithRegistration) {
			const selectedItems = [];
			selected.forEach(item => {
				const selectedItem = galleryData.gallery.find(galleryItem => galleryItem.id === item);
				if (selectedItem) {
					selectedItems.push(selectedItem);
				}
			});

			const setRegistredUserVotesRequest = {
				collection: COLLECTIONS.REGISTREDUSERSVOTES,
				data: {
					userUid: userInfo.uid,
					checklistId: id,
					votedItems: selectedItems,
					votedItemsCount: selectedItems.length,
					userPhoneNumber: userInfo.phoneNumber,
				},
			};

			await setRegistredUserVotesInfo(setRegistredUserVotesRequest);
			localStorage.setItem(`voted-checklist-with-registration-${id}`, `true`);
		}

		if (_.size(this.selectedItems)) {
			const items = [];
			_.forEach(this.selectedItems, item => {
				const nameForAnalytics = _.get(item, 'nameForAnalytics', '');
				items.push(nameForAnalytics);
			});
			analytics.gtag.event('done', { CUSTOM_PARAMETER: items.join(', ') });
			// console.info(items);
		}
		if (isOneVotingPerUser) {
			localStorage.setItem(`checklist-${checklistInfo.name}`, `true`);
		}
		// SPECIAL only for these 2 checklists ('/eretznehederetvideo', '/eretznehederetsongs')
		if (location.pathname === '/eretznehederetvideo' || location.pathname === '/eretznehederetsongs') {
			if (location.pathname === '/eretznehederetvideo') {
				if (window) {
					window.open('https://list.mako.co.il/eretznehederetsongs', '_self');
				}
			}
			if (location.pathname === '/eretznehederetsongs') {
				if (window) {
					window.open('https://list.mako.co.il/eretznehederetcharacters', '_self');
				}
			}
		} // SPECIAL only for these 2 checklists ('/commercials','/commercialstage2')
		else if (
			location.pathname === '/commercials' ||
			location.pathname === '/commercialstage2' ||
			location.pathname === '/commercialstage3'
		) {
			if (location.pathname === '/commercials') {
				if (window) {
					window.open('https://list.mako.co.il/commercialstage2', '_self');
				}
			}
			if (location.pathname === '/commercialstage2') {
				if (window) {
					window.open('https://list.mako.co.il/commercialstage3', '_self');
				}
			}
			if (location.pathname === '/commercialstage3') {
				if (window) {
					window.open('https://list.mako.co.il/commercialstage4', '_self');
				}
			}
		} else {
			this.props.onFinishClick();
		}
	};

	onCreditClick = e => {
		if (!_.trim(e.currentTarget.getAttribute('href'))) {
			e.preventDefault();
		}
	};

	onPopUpLinkClick = (id: string) => {
		const { gallery } = this.state;
		const activeItem = gallery.find(item => item.id === id);

		if (document) {
			// document.body?.style.overflow = 'hidden';
			const header = document.getElementById('header');
			const bottomBar = document.getElementById('bottomBar');
			if (header && bottomBar) {
				header.style.display = 'none';
				bottomBar.style.display = 'none';
			}
		}
		if (activeItem && activeItem.title) {
			// ga.onItemTextClick(activeItem.title);
		}
		this.setState({ isActivePopUp: true, activePopUpItem: id });
	};

	onLinkClick = (name: string) => {
		analytics.gtag.event('Click Item link', { CUSTOM_PARAMETER: name });
	};

	onExitPopUpClick = () => {
		if (document) {
			const header = document.getElementById('header');
			const bottomBar = document.getElementById('bottomBar');

			if (header && bottomBar) {
				header.style.display = '';
				bottomBar.style.display = '';
			}
		}
		this.setState({ isActivePopUp: false });
	};

	setActiveVideo = e => {
		const { id, anlyticsname } = e.currentTarget.dataset;
		analytics.gtag.event('Play video', { CUSTOM_PARAMETER: anlyticsname });
		this.setState({
			activeVideoId: id,
		});
	};

	renderItem = item => {
		const { checklistInfo } = this.props;
		const hoverItemColor = _.get(checklistInfo, 'graphics.hoverItemColor', '');
		const activeClass = this.state.selected.includes(`${item.id}`) ? css.active : '';
		const isSelected = !!this.state.selected.includes(`${item.id}`);
		const image = _.get(item, 'image', {});
		const name = _.get(item, 'title', '');
		const subtitle = _.get(item, 'subTitle', '');
		const btnName = _.get(item, 'buttonText', '');
		const btnLink = _.get(item, 'buttonLink', '');
		const btnLinkPopUp =
			_.get(item, 'isPopUpLinkActive') ||
			_.get(item, 'isImagePopUpActive') ||
			_.get(item, 'isVideoPopUpActive', false);
		const selectedIcon = _.get(checklistInfo, 'graphics.selectIcon', {});
		const isItemGradientEnabled = _.get(checklistInfo, 'graphics.isItemGradientEnabled', false);
		const numberOfChoices = _.get(checklistInfo, 'general.numberOfChoices', 0);
		const type = _.get(checklistInfo, 'cardsType', '0');
		const { activeVideoId } = this.state;
		const isWithVideo = item.frameVideo;
		const itemShareDescription = _.get(checklistInfo, 'general.shareDescriptionForItem', '').replace(
			'{#####}',
			item.title
		);
		const selectedItemBorderColor = _.get(
			checklistInfo,
			'graphics.selectedHorizontalItemBorderColor',
			'rgba(0, 78, 233, 1)'
		);

		const itemShareTitle = _.get(checklistInfo, 'general.shareTitleForItem', '').replace('{#####}', item.title);
		const isShowSocialls = _.get(checklistInfo, 'general.isShowSharesForItem', false);

		// This functionality need only if use mp4 format in popup and numberOfChoice equal to 0
		const popUpLinkVideo = _.get(item, 'popUpVideo', '');
		const isZeroNumberOfChoice = numberOfChoices === 0;
		const disableClickWholeItem = isZeroNumberOfChoice && !popUpLinkVideo;
		// This functionality only for horizontal type checklists
		const isBlackColorItemBottomArea = _.get(checklistInfo, 'graphics.isBlackColorForBottomTextArea', false);
		// Item for horizontal type checklist
		if (type === '1') {
			return (
				<div className={classNames(css.categoryItemHorizontal)} key={item.id}>
					<div
						className={css.wrapper}
						style={{ borderColor: isBlackColorItemBottomArea ? '#000' : 'rgba(255, 255, 255, 0.7)' }}
					>
						<div
							className={classNames(css.frameWrapper, isSelected && css.selected)}
							style={{ borderColor: isSelected ? selectedItemBorderColor : 'transparent' }}
						>
							{isWithVideo && (
								<>
									<div
										className={classNames(css.coverWrapper)}
										style={{ backgroundImage: `url('${fileLink(image)}')` }}
										data-id={item.id}
										data-anlyticsname={item.nameForAnalytics}
										onClick={this.setActiveVideo}
									>
										<div
											className={css.playBtn}
											// data-id={item.id}
											// data-anlyticsname={item.nameForAnalytics}
											// onClick={this.setActiveVideo}
										>
											<img src={playIconSrc} alt="play-icon" />
										</div>
										{!_.isEmpty(item.credit) && (
											<div className={css.creditWrapper}>
												<a
													className={css.credit}
													href={item.creditLink}
													target="_blank"
													rel="noopener noreferrer"
													onClick={this.onCreditClick}
												>
													{item.credit}
												</a>
											</div>
										)}
									</div>
									{activeVideoId === item.id && item.frameVideo && item.frameVideoPlayer && (
										<VideoFrame source={item.frameVideo} playerType={item.frameVideoPlayer} />
									)}
								</>
							)}
							{!isWithVideo && (
								<>
									<div
										className={classNames(
											css.coverWrapper,
											numberOfChoices === 0 && css.disabled,
											css.withoutVideo
										)}
										style={{ backgroundImage: `url('${fileLink(image)}')` }}
										onClick={this.onItemClick}
										data-id={item.id}
										data-title={item.nameForAnalytics}
									>
										{!_.isEmpty(item.credit) && (
											<div className={css.creditWrapper}>
												<a
													className={css.credit}
													href={item.creditLink}
													target="_blank"
													rel="noopener noreferrer"
													onClick={this.onCreditClick}
												>
													{item.credit}
												</a>
											</div>
										)}
									</div>
								</>
							)}
						</div>
						<div className={css.infoBlock}>
							<div
								className={css.topInfo}
								data-title={item.nameForAnalytics}
								data-id={item.id}
								onClick={
									Responsive.isMatching(Responsive.NO_MOBILE)
										? this.onItemClick
										: () => {
												return null;
										  }
								}
							>
								<div className={css.text}>
									<p style={{ color: isBlackColorItemBottomArea ? '#000' : '#fff' }}>{item.title}</p>
									<p style={{ color: isBlackColorItemBottomArea ? '#000' : '#fff' }}>
										{item.subTitle}
									</p>
								</div>
								{numberOfChoices !== 0 && (
									<SelectBtn
										checklistInfo={checklistInfo}
										isSelected={isSelected}
										title={item.title}
										id={item.id}
										onClickBtn={
											Responsive.isMatching(Responsive.NO_MOBILE)
												? () => {
														return null;
												  }
												: this.onItemClick
										}
									/>
								)}
							</div>
							{isShowSocialls && (
								<div className={css.sociallsWrapper}>
									<Socials
										inItemLocated
										shareItemId={item.id}
										itemShareDescription={itemShareDescription}
										itemShareTitle={itemShareTitle}
										iconsColor={isBlackColorItemBottomArea ? '#000' : '#fff'}
									/>
								</div>
							)}
							<ExpandText checklistInfo={checklistInfo} itemInfo={item} />
						</div>
					</div>
				</div>
			);
		}

		return (
			<div
				className={classNames(css.categoryItem, activeClass, isZeroNumberOfChoice && css.disabled)}
				key={item.id}
				// this functionality only for items which has video in popup and when number of choices must be 0
				onClick={
					disableClickWholeItem
						? () => {
								return null;
						  }
						: () => {
								if (!isZeroNumberOfChoice) return null;
								this.onPopUpLinkClick(item.id);
						  }
				}
			>
				<div
					className={classNames(css.img, isZeroNumberOfChoice && css.disabled)}
					onClick={this.onItemClick}
					data-id={item.id}
					data-title={item.nameForAnalytics}
				>
					<div className={css.imgBlock} style={{ backgroundImage: `url('${fileLink(image)}')` }} />
					{!_.isEmpty(item.credit) && (
						<div className={css.creditWrapper}>
							<a
								className={css.credit}
								href={item.creditLink}
								target="_blank"
								rel="noopener noreferrer"
								onClick={this.onCreditClick}
							>
								{item.credit}
							</a>
						</div>
					)}

					{isItemGradientEnabled && <div className={css.gradient} />}
					<div className={css.checkIcon} style={{ backgroundImage: `url('${fileLink(selectedIcon)}')` }} />
				</div>
				<EqualHeightElement name="gal-item">
					<div className={css.bottomBtn}>
						{name && <p>{name}</p>}
						{subtitle && <h6 className={css.subTitle}>{subtitle}</h6>}

						{btnName && btnLink && !btnLinkPopUp && (
							<a
								href={btnLink}
								target="_blank"
								rel="noopener noreferrer"
								className={css.link}
								onClick={() => this.onLinkClick(name)}
							>
								{btnName}
							</a>
						)}
						{btnLinkPopUp && (
							<button
								type="button"
								className={css.buttonPopUp}
								onClick={() => this.onPopUpLinkClick(item.id)}
							>
								{btnName}
							</button>
						)}
					</div>
				</EqualHeightElement>
				<div className={css.hoverBlock} style={{ backgroundColor: hoverItemColor }}></div>
			</div>
		);
	};

	renderPopUp = () => {
		const { isActivePopUp, gallery, activePopUpItem } = this.state;
		const item = _.find(gallery, ['id', activePopUpItem]);
		const isAutoplayVideo = _.get(item, 'isAutoplayVideo', false);
		let videoLink;

		if (typeof _.get(item, 'popUpVideo', '') === 'object') {
			videoLink = _.get(item, 'popUpVideo', '') ? fileLink(item?.popUpVideo) : '';
		} else {
			videoLink = item?.isVideoPopUpActive ? _.get(item, 'popUpVideo') : '';
		}

		// this functionality only for video which has mp4 format
		const isMp4Video =
			videoLink
				.split('/')
				.pop()
				.split('.')
				.pop() === 'mp4';

		return (
			<div className={classNames(css.popUpWrapper, isActivePopUp ? css.activePopUp : '')}>
				<div className={css.popUpBg} onClick={this.onExitPopUpClick}></div>
				<div className={classNames(css.popUp)}>
					<button type="button" className={css.closeButton} onClick={this.onExitPopUpClick}>
						<div className={css.closeIcon}></div>
					</button>
					{videoLink ? (
						<div className={classNames(css.videoWrapper, isMp4Video && css.withMpFourVideo)}>
							{isMp4Video ? (
								<video
									src={isActivePopUp ? videoLink : ''}
									autoPlay={isAutoplayVideo}
									controls={!isAutoplayVideo}
									playsInline
									controlsList="nodownload"
								></video>
							) : (
								<iframe
									title={item?.title}
									width="100%"
									height="100%"
									src={isActivePopUp ? videoLink : ''}
									frameBorder="0"
								></iframe>
							)}
						</div>
					) : (
						<img src={item?.image && fileLink(item.image)} alt="" />
					)}
					<div className={classNames(css.bottomWrapper, !item?.popUpText && css.smallPadding)}>
						<p className={css.popUpTitle}>{item?.title}</p>
						<p className={css.popUpDescription}>{item?.popUpText}</p>
					</div>
				</div>
			</div>
		);
	};

	renderItems = () => {
		const { gallery } = this.state;

		return (
			<div className={css.itemsWrapper}>
				{this.renderPopUp()}

				{gallery.map((item, index) => {
					return this.renderItem(item);
				})}
			</div>
		);
	};

	renderCount = () => {
		const { selected } = this.state;
		const { checklistInfo, galleryData } = this.props;
		const isMultiple = Number(_.get(checklistInfo, 'general.isMultiple', '0'));
		const galleryItems = _.get(galleryData, 'gallery', []);
		const totalGalleryItems = _.size(galleryItems);
		const selectedTotal = _.size(selected);
		const numberOfChoices = _.get(checklistInfo, 'general.numberOfChoices', 3);
		const isMultipleItems = +isMultiple ? totalGalleryItems : numberOfChoices;

		const allItemsNumberSubstr = '{all_items_number}';
		const chosenItemsNumberSubstr = '{chosen_items_number}';
		const progressLineText = _.get(checklistInfo, 'graphics.progressLineText', '');
		const textColor = _.get(checklistInfo, 'graphics.progressLineTextColor', 'rgba(255, 255, 255, 1)');
		// replace template string from admin pannel to real chosen data
		const progressLineTextEdited = progressLineText
			.replace(`${chosenItemsNumberSubstr}`, selectedTotal)
			.replace(`${allItemsNumberSubstr}`, isMultipleItems);

		return <p style={{ color: textColor }}>{progressLineTextEdited}</p>;
	};

	barRender = () => {
		const { selected, finishButtonClicked } = this.state;
		const { galleryData, checklistInfo } = this.props;
		const numberOfChoices = _.get(checklistInfo, 'general.numberOfChoices', 3);

		const galleryItems = _.get(galleryData, 'gallery', []);
		const selectedTotal = _.size(selected);
		const itemsTotal = _.size(galleryItems);
		const isMultiple = Number(_.get(checklistInfo, 'general.isMultiple', '0'));
		const progressTransform = isMultiple
			? `translateX(${100 - (selectedTotal / itemsTotal) * 100}%)`
			: `translateX(${100 - (selectedTotal / numberOfChoices) * 100}%)`;
		const btnColor = _.get(checklistInfo, 'graphics.buttonsTextColor', '');
		const btnBg = _.get(checklistInfo, 'graphics.buttonsBackgroundColor', '');
		const progressLineColor = _.get(checklistInfo, 'graphics.progressLineColor', '');
		const wrapperBg = _.get(checklistInfo, 'graphics.progressWrapperBackground', '#fff');

		return (
			<div className={classNames(css.bar, selectedTotal ? css.in : '')} id="bottomBar">
				<div className={css.inner} style={{ backgroundColor: wrapperBg }}>
					<div className={css.container}>
						<div className={css.barContent}>
							{(isMultiple || numberOfChoices !== 1) && (
								<div className={css.barInfo}>
									<div className={css.barProgress}>
										<div
											className={css.overlay}
											style={{ backgroundColor: progressLineColor }}
										></div>
										<div
											className={css.line}
											style={{
												WebkitTransform: progressTransform,
												transform: progressTransform,
												backgroundColor: progressLineColor,
											}}
										/>
									</div>
									<div className={css.countAndAction}>{this.renderCount()}</div>
								</div>
							)}
							<div className={css.barActions}>
								<button
									className={classNames(
										css.doneBtn,
										isMultiple && css.short,
										finishButtonClicked && css.disabled
									)}
									onClick={this.onFinishClick}
									type="button"
									style={{ color: btnColor, backgroundColor: btnBg }}
								>
									סיימתי
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	};

	render() {
		const { isShowMaxPopup, loaded } = this.state;
		const { className, transitionState, checklistInfo, parentURL, location } = this.props;
		const desktopBgImage = _.get(checklistInfo, 'graphics.galleryBackground', {});
		const mobileBgImage = _.get(checklistInfo, 'graphics.galleryBackgroundMobile', {});
		const titleColor = _.get(checklistInfo, 'graphics.mainTitleColor', '#fff');
		const subTitleColor = _.get(checklistInfo, 'graphics.mainSubTitleColor', '#fff');
		const bodyBackground = _.get(checklistInfo, 'graphics.bodyBackgroundColor', '#000');
		const cooladataChannelId = _.get(checklistInfo, 'general.cooladataChannelID', '');
		const cooladataId = _.get(checklistInfo, 'general.cooladataID', '');
		const isHideMainPage = _.get(checklistInfo, 'general.isHideMainPage', false);
		const embedCode = decodeURIComponent(_.get(checklistInfo, 'general.pixelEnd', ''));

		const titleText = _.get(checklistInfo, 'main.mainTitle', '');
		const subtitleText = _.get(checklistInfo, 'main.mainSubTitle', '');
		const type = _.get(checklistInfo, 'cardsType', '0');

		const galleryFooterText = _.get(checklistInfo, 'graphics.galleryFooterText', '');
		const isBlackGalleryFooterText = _.get(checklistInfo, 'graphics.isBlackGalleryFooterText', false);

		return (
			<>
				<div
					className={classNames(css.mainContent, css[transitionState], className)}
					style={{ backgroundColor: bodyBackground }}
				>
					{Responsive.isMatching(Responsive.NO_MOBILE) && !_.isEmpty(desktopBgImage) && (
						<div
							className={css.bgDesktop}
							style={{ backgroundImage: `url('${fileLink(desktopBgImage)}')` }}
						/>
					)}
					{Responsive.isMatching(Responsive.MOBILE) && !_.isEmpty(mobileBgImage) && (
						<div
							className={css.bgMobile}
							style={{ backgroundImage: `url('${fileLink(mobileBgImage)}')` }}
						/>
					)}
					{type === '1' && Responsive.isMatching(Responsive.NO_MOBILE) && (
						<div
							className={css.fakeBgForHorizonral}
							style={{
								backgroundColor: bodyBackground,
								backgroundImage: !_.isEmpty(desktopBgImage) ? `url('${fileLink(desktopBgImage)}')` : '',
							}}
						></div>
					)}
					<EqualHeight timeout={0} updateOnChange={loaded}>
						<div className={classNames(css.container, type === '1' && css.horizontal)}>
							{isHideMainPage && (
								<div className={css.campaignDescription}>
									{titleText && (
										<div className={css.title} style={{ color: titleColor }}>
											{titleText}
										</div>
									)}
									{subtitleText && (
										<div className={css.subTitle} style={{ color: subTitleColor }}>
											{subtitleText}
										</div>
									)}
								</div>
							)}

							{this.renderItems()}
							{galleryFooterText && (
								<div
									className={classNames(css.galleryFooterText, type === '1' && css.forHorizontal)}
									style={{ color: isBlackGalleryFooterText ? '#2B2C2F' : '#fff' }}
								>
									{galleryFooterText}
								</div>
							)}
						</div>
					</EqualHeight>

					{this.barRender()}
					<div className={css.rabbiCredit} dir="ltr">
						<RabbiCredit theme="light" location={location} />
					</div>
					<BottomLink />
					<MakoAnalytics
						pageId={MAKO_ANALYTICS_PAGE_IDS.GALLERY}
						channelId={cooladataChannelId}
						cooladataId={cooladataId}
						projectURL={parentURL}
					/>

					{this.state.finishButtonClicked && !_.isEmpty(embedCode) && <Embed code={embedCode} />}
				</div>
				<div className={classNames(css.maxPopup, isShowMaxPopup && css.show)}>
					<div className={css.maxPopupInner}>
						<p>הגעת למקסימום הצבעות</p>
						<div className={css.close} onClick={this.onCloseMaxPopup}></div>
					</div>
				</div>
			</>
		);
	}
}

export default withTransition(MainContent);
